import {useEffect, useState, useRef} from 'react'
import { useParams } from 'react-router';
import { useNavigate } from 'react-router-dom';
import PageApp from '../../../Page';
import ModalEdit from './AddEdit'
import { HomeOutlined, UnorderedListOutlined, ClockCircleFilled, ExclamationCircleFilled } from '@ant-design/icons';
import {Table, Empty, Modal, Divider, Button, message, Space, Tag} from 'antd';
import {getAllByConcept, drop} from '../../../../apis/FormulaApi';
import _ from 'lodash'

const { confirm } = Modal;

const routes = [  {
    href: '',
    title: <>
      <HomeOutlined />
      <span>Inicio</span>
    </>,
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Catálogos</span>
      </>
    ),
  },
  {
    href: '../concepto',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Conceptos</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Formulas</span>
      </>
    ),
}];

const Formulas = () => {
    let navigate = useNavigate();
    const { conceptId } = useParams();
    const [items, setItems] = useState([]);
    const [openEdit, setOpenEdit] = useState(false);
    const [objectSelected, setObjectSelected] = useState(null);
    const [loading, setLoading] = useState(true);
    
    const columns = [
      {
        title: 'Descripción',
        dataIndex: 'descripcion',
        key: 'descripcion',
      },
      {
        title: 'Formula',
        dataIndex: 'formula',
        key: 'formula',
      },
      {
        title: 'Activo',
        dataIndex: 'activo',
        key: 'activo',
        render: (item, object)=> {
          if(item == true){
              return  <Tag color="green">Sí</Tag>;
          }else{
              return  <Tag color="red">No</Tag>;
          }
        }
      },
      {
        title: '',
        dataIndex: 'actions',
        key: 'actions',
        render: (item, object)=> {
          return <Space>
            <Button type='primary' size='small' onClick={()=>{
                openDetails(object);
            }}>Editar</Button>
            <Button type='primary' size='small' danger onClick={()=>{
                deleteConfirm(object);
            }}>Eliminar</Button>
          </Space>
        }
      }
    ];

    const openDetails = async (object)=>{
      setOpenEdit(true);
      setObjectSelected(object);
    }

    const deleteConfirm = async (item) => {
        confirm({
            title: '¿Confirmas en eliminar el concepto?',
            icon: <ExclamationCircleFilled />,
            content: 'No podrás recuperar su información',
            onOk: ()=>{deleteOk(item.id)},
            onCancel() {
                console.log('Cancel');
            },
        });
    }

    const deleteOk = async (id)=>{
        const response = await drop(id);
        if(response.ok){
            message.success('¡El concepto ha sido eliminadó!');
        }
        await refreshData();
    }

    const btnClick = ()=>{
      setOpenEdit(true);
      setObjectSelected(null);
    }

    const onHandlerFinish = async (refresh) => {
      setOpenEdit(false);
      if(refresh){
        await refreshData();
      }
    }

    const refreshData = async ()=> {
      const response = await getAllByConcept(conceptId);
      if(response.ok){
        let items = response.payload;
        setItems(items);
      }

      setLoading(false);
    }

    const effectRan = useRef(false);
    useEffect(() => {

      if (!effectRan.current) {
        (async () => {
          await refreshData();
        })();
      }
    
      return () => effectRan.current = true;
    }, []);
    
    return <PageApp routes={routes} title={'Formulas'} 
    cardTitle={'Lista de formulas'}
    extraCard={[
      <Button type="primary" onClick={btnClick}>
          Agregar Formula
      </Button>
    ]}>
      {
          loading ? (
            <p>Loading...</p>
          ) : <>
            {
              items.length == 0 ? <Empty />:
              <Table dataSource={items} columns={columns} />
            }
          </>
      }
      {
        (openEdit && objectSelected && objectSelected.id > 0) &&
        <ModalEdit title={"Editar Formula"} id={objectSelected.id} open={openEdit} finish={onHandlerFinish}/>
      }
      {
        (openEdit && !objectSelected) &&
        <ModalEdit title={"Crear Formula"} open={openEdit} finish={onHandlerFinish}/>
      }
    </PageApp>
}   

export default Formulas;
